module.exports = __webpack_public_path__ + "static/graf-b6d04a5efa34d2619cb92d1833e7e534.png";